const messages = {
  title: 'Dostop zavrnjen',
  description: 'Nimate dostopa do tega vira',
  backHomeButton: 'Nazaj na nadzorno ploščo'
}

export default {
  messages
}
